import React, { Component } from "react";
import ReportTableDayContent from "./ReportTableDayContent";
import styles from "./../reportTable.module.scss";
import { v4 as uuidv4 } from "uuid";

class ReportTableDaysContent extends Component {
  render() {
    const { days } = this.props;

    return days.map((day) => {
      return [
        <div key={uuidv4()} className={styles.reportTableDayContainer}>
          <b>{day.day}</b>
        </div>,
     
        <ReportTableDayContent key={uuidv4()} day={day} />,
      ];
    });
  }
}

export default ReportTableDaysContent;
